import type {createSafeIndexedDbPersister} from '@github-ui/safe-indexed-db-storage'
import type {Sink} from 'relay-runtime/lib/network/RelayObservable'

declare const InvalidBrand: unique symbol
export type Invalid = {
  readonly [InvalidBrand]: true
}
export const INVALID: Invalid = {} as Invalid

export type CacheHitSource = 'indexed-db' | 'hot-cache' | 'service-worker'

export type CacheKey = string

export type CachedQuery<T> = {
  queryHash: string
  variables: Record<string, unknown>
  state: {
    data: T | null
    updatedAt?: number
  }
}

export type Storage = ReturnType<typeof createSafeIndexedDbPersister>

export const INTERNAL_ONLY_ATTRIBUTES = {
  EXCLUDE_FROM_CACHE_KEY: 'exclude_from_cache_key' as const,
  SKIP_NETWORK: 'skip_network' as const,
}

export type QueryAttributes = {
  preheat_source?: string
  skip_cache?: boolean
  [INTERNAL_ONLY_ATTRIBUTES.EXCLUDE_FROM_CACHE_KEY]?: string[]
  [INTERNAL_ONLY_ATTRIBUTES.SKIP_NETWORK]?: boolean
}

export type QueryParameters = {
  queryId: string
  queryName: string
  variables: Record<string, unknown>
}

export type PersisterCallbacks<T> = {
  queryFn: (isCacheRefresh?: boolean) => Promise<T>
  observer: Sink<T>
  preloadSubscriptions?: (resolved: T | undefined) => void
}
